var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"align-center":"","justify-space-between":""}},[_c('span',{staticClass:"text--m font-weight-medium"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"font-weight-medium text--xxl secondary--text d-inline-block ml-4"},[_vm._v(_vm._s(_vm.amount))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }